import React from 'react'
import { Popover } from 'react-tiny-popover'

const PopOver = ({ isOpen, content, ...rest }) => {
  return (
    <Popover
      containerClassName="!z-[50]"
      isOpen={isOpen}
      reposition={false}
      positions={['bottom']}
      content={content}
      {...rest}
    >
      <div></div>
    </Popover>
  )
}

export default PopOver
